import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getPresenceHistory = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/monitoring-host/details?${queries}` });

  return data?.data;
};

export default getPresenceHistory;
